(function () {

    'use strict';

    angular
        .module('app.layout')
        .controller('PageNotFoundController', [
            '$window',
            'ApiService',
            'DataService',
            'CommonUtil',
            PageNotFoundController
        ]);

    function PageNotFoundController($window, apiService, dataService, commonUtil) {
        var vm = this;

        init();

        function init() {
        	vm.langCode = 'en';
        	apiService.getLanguages().then(function (response) {
            	var browserLanguageCode = [dataService.getLanguageCodeFromCookie()];
            	if (angular.isArray($window.navigator.languages)) {
                	browserLanguageCode.push($window.navigator.languages[0]);
            	} else {
                	browserLanguageCode.push($window.navigator.userLanguage);
            	}
            	var selectedLanguage = commonUtil.getDisplayLanguageFromCodeList(response.data, browserLanguageCode);
            	if (angular.isDefined(selectedLanguage)) {
            		vm.langCode = selectedLanguage.languageCode;
            	}
        	});
        }
    }

})();


// WEBPACK FOOTER //
// ./app/layout/pagenotfound/PageNotFoundController.js